

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const LOGINOPERATOR= createAsyncThunk(
  "loginOperator/loginOperator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const loginOperatorSlice = createSlice({
  name: "loginOperatorSlice",
  initialState: {
    loginOperator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfloginOperator: (state) => {
        state.loginOperator.loading = false
        state.loginOperator.error = false
        state.loginOperator.data = []
        state.loginOperator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(LOGINOPERATOR.fulfilled, (state, action) => {
      state.loginOperator = {
        ...state.loginOperator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LOGINOPERATOR.pending, (state, action) => {
      state.loginOperator = {
        ...state.loginOperator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LOGINOPERATOR.rejected, (state, action) => {
      state.loginOperator = {
        ...state.loginOperator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const loginOperatorAction = {
    LOGINOPERATOR,
};

export { loginOperatorAction };
export default loginOperatorSlice.reducer;
export const {setInitialStateOfloginOperator} = loginOperatorSlice.actions
